import { View, Text } from "react-native";
import React, { useState } from "react";
import * as Print from "expo-print";
import { styles } from "../styles/mainStyle";
import { Button } from "@rneui/base";
import Ionicons from "@expo/vector-icons/Ionicons";
import { TouchableOpacity } from "react-native";

const Imprimir = ({ navigation, route }) => {
  const [selectedPrinter, setSelectedPrinter] = useState();
  const html = "";
  const print = async () => {
    // On iOS/android prints the given html. On web prints the HTML from the current page.
    await Print.printAsync({
      html,
      printerUrl: selectedPrinter?.url, // iOS only
    });
  };

  const printToFile = async () => {
    // On iOS/android prints the given html. On web prints the HTML from the current page.
    const { uri } = await Print.printToFileAsync({ html });
    console.log("File has been saved to:", uri);
    await shareAsync(uri, { UTI: ".pdf", mimeType: "application/pdf" });
  };

  const selectPrinter = async () => {
    const printer = await Print.selectPrinterAsync(); // iOS only
    setSelectedPrinter(printer);
  };

  return (
    <View>
      <View style={styles.headerContainer}>
        <Ionicons
          name="arrow-undo-outline"
          size={32}
          color="white"
          onPress={() => props.navigation.navigate("Home")}
        />

        <TouchableOpacity onPress={() => navigation.navigate("Home")}>
          <Text style={styles.headerTitle}>
            {route.params.user.replace("@mail.com", "")}
          </Text>
        </TouchableOpacity>
        <Ionicons
          name="print-outline"
          size={32}
          color="white"
          onPress={printToFile}
        />
      </View>
      <Text>
        <b>Cliente:</b> {route.params.user.replace("@mail.com", "")}
      </Text>
      <Text>
        <b>Envío:</b> {route.params.transporte}
      </Text>
      {route.params.transporteInfo != "" && (
        <Text>
          <b>Nombre:</b> {route.params.transporteInfo}
        </Text>
      )}
      {route.params.transporTel != "" && (
        <Text>
          <b>Teléfono:</b> {route.params.transporTel}
        </Text>
      )}
      <Text>
        <b>Método de pago:</b> {route.params.pago}
      </Text>
      {route.params.items.map((item, index) => {
        return (
          <View style={styles.cartItemImp}>
            <Text>
              <b>{item.name}</b> {item.sku}
            </Text>

            <Text>Unidades: {item.quantity}</Text>
          </View>
        );
      })}
    </View>
  );
};

export default Imprimir;
